import { render, staticRenderFns } from "./B-11__SocialRespCreate.vue?vue&type=template&id=50ae0a8e&"
import script from "./B-11__SocialRespCreate.vue?vue&type=script&lang=js&"
export * from "./B-11__SocialRespCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VForm,VSpacer})
